export const Styles = (theme) => ({
    root: {
      ...theme.mixins.gutters(),
      paddingTop: theme.spacing.unit * 2,
      paddingBottom: theme.spacing.unit * 2,
      width: "100%",
      alignSelf: "center",
      marginLeft: "auto",
      marginRight: "auto",
    },
    alignCenter: {
      textAlign: "center",
      width: "100%",
    },
    margins: {
      marginLeft: "10px",
      marginRight: "10px",
    },
    margins1: {
      marginLeft: "2px",
      marginRight: "10px",
    },
    modifiedButton: {
      color: "#fff",
      backgroundColor: "#0089cf",
      borderColor: "#0089cf",
      height: "30px",
      "&:hover": {
        backgroundColor: "#243a6f",
        borderColor: "#243a6f",
        "& span": {
          color: "#fff !important",
        },
      },
    },
  
    modifiedButton1: {
      border: "0.5px solid #0089cf ",
      color: "#0089cf",
      height: "30px",
      fontWeight: "600",
      marginLeft: "10px",
      "&:hover": {
        backgroundColor: "#6C757D",
        border: "1px solid #cfcfcf !important",
        "& span": {
          color: "#fff !important",
        },
      },
    },
    div1: {
      alignSelf: "center",
      borderRadius: "1px solid grey",
      marginLeft: "auto",
      marginRight: "auto",
      width: "fit-content",
    },
    div2: {
      width: "95%",
      marginLeft: "auto",
      alignSelf: "center",
      marginRight: "auto",
      display: "flex",
      flexWrap: "wrap",
    },
    div3: {
      alignSelf: "left",
      marginLeft: "auto",
      //marginRight: "auto",
      width: "fit-content",
    },
    table: {
      width: "90%",
      alignSelf: "center",
      marginLeft: "auto",
      marginRight: "auto",
    },
    fieldset: {
      margin: "10px",
      padding: "0 10px 10px",
      border: "1px solid #9e8e8e",
      borderRadius: "8px",
      paddingTop: "10px",
    },
    legend: {
      padding: "2px 4px",
      background: "#dfe2ee",
      border: "1px solid lightgrey",
      borderRadius: "1px",
      textAlign: "center",
    },
    submit: {
      width: "100px",
    },
    button: {
      margin: theme.spacing.unit,
      color: "#fff",
      fontSize: "10px",
      padding: "9px 5px",
      backgroundColor: "#389bde",
      borderRadius: "90px",
      boxShadow:
        "0px 1px 2px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0,0,0,0.24), 0px 3px 1px -2px rgba(0,0,0,0.02)",
      [theme.breakpoints.down("sm")]: {
        fontSize: "8px",
        width: "80px",
      },
    },
    formLabel: {
      fontSize: "12px !important",
      color: "rgba(39, 108, 155, 1)",
      fontWeight: "450",
    },
    checkboxmember: {
      fontSize: "16px",
      color: "rgba(39, 108, 155, 1)",
    },
    popUpIcons: {
      fontSize: "24px",
      paddingLeft: "20px",
      paddingRight: "20px",
      paddingTop: "25px",
      cursor: "pointer",
      float: "right !important",
    },
    buttonmargin: {
      textAlign: "center",
    },
    container: {
      display: "flex",
      flexWrap: "wrap",
      width: "fit-content",
      marginTop: "10px",
      marginBottom: "10px",
      marginRight: "15px",
    },
    container1: {
      width: "229px",
      marginTop: "98px",
      marginRight: "20px",
      marginLeft: "12px",
    },
    validationMessage: {
      color: "red",
      fontSize: "12px",
      marginLeft: "25px",
      width: "180px",
    },
    inlineBlock: {
      display: "inline-block",
    },
    centerAlign: {
      textAlign: "center",
    },
    fetchbuttonconatiner: {
      float: "right",
      marginRight: "20px",
      marginTop: "50px",
    },
    fetchstyle1: {
      marginLeft: "190px",
      color: "red",
      fontSize: "12px",
    },
    fetchstyle: {
      textAlign: "left",
      marginLeft: "20px",
      marginTop: "30px",
    },
    fetchcontainer: {
      height: "130px",
      padding: "10px",
    },
    tabmargin: {
      marginLeft: "16px",
    },
    textFieldPopup: {
      width: "180px",
    },
    radioButton: {
      fontSize: "16px !important",
      paddingLeft: "5px",
    },
    printCodesDiv: {
      display: "flex",
      flexWrap: "wrap",
      flexDirection: "row",
      width: "234px",
    },
    printIdInputFieldDiv: {
      width: " 170px",
      display: "flex",
      flexWrap: "wrap",
      flexDirection: "row",
      textAlign: "left",
      marginLeft: "6px",
    },
    labelAutoComplete: {
      fontSize: "1.1rem",
      fontWeight: "600",
      minWidth: "165%",
      color: "#053674 !important",
      marginBottom: "12px",
    },
    pcpField:{
      marginLeft:"15px"
    },
    assignPCPPopup: {
      height: "90vh",
      width: "70vw",
      overflowY:"scroll",
      overflowX:"hidden"
    },
    assignPCPBanner: {
      display: "flex",
      height: "60px",
    },
    legendAlign: {
      textAlign: "left",
      flexDirection: "row",
      width: "30%",
      padding: "8px",
      // fontSize:14,
    },
    closeIconAlign: {
      fontSize: "20px",
      color: "black",
      width: "100%",
      textAlign: "right",
      marginTop: "10px",
    },
    assignPCPFieldBox: {
      display: "flex",
      //justifyContent: "space-evenly",
      //marginRight: "21px",
      flexWrap: "wrap",
      fontSize:"12px"
    },
    fieldColumnBox: {
      display: "flex",
      flexDirection: "column",
    },
    fieldColumnBox1: {
      display: "flex",
      flexDirection: "column",
      alignContent: "left",
    },
    boldText: {
      fontSize: "1.1em",
      fontWeight: "700",
    },
    assignPCPFields: {
      display: "flex",
      // marginLeft: "21px",
      marginRight: "21px",
      flexWrap: "wrap",
      justifyContent: "space-between",
      marginLeft:"-5px",
    },
    googleMap: {
      margin: "10px",
      height: "60%",
      width: "98%",
    },
    heading: {
      fontWeight: "bold",
      color: "rgb(0, 137, 207)",
    },
    headingMargin: {
      margin: "10px 10px 10px 21px",
    },
  });
  